import { AppUserShared } from "../AppUser.model";
import { Blackbox } from "../blackbox";
import { Log } from "../eventTracking";
import { File } from "../File.model";
import { Permission } from "../Permission.model";
import { Tag } from "../Tag.model";
import { IssueAssignee } from "./IssueAssignee.model";
import { IssueCustomField } from "./IssueCustomField.model";
import { IssuePriority } from "./IssuePriority.model";
import { IssueServiceHookPermalink } from "./IssueServiceHookPermalink.model";
import { IssueStatus } from "./IssueStatus.model";

export enum ReportType {
  AUTOMATIC = "automatic",
  MANUAL = "manual",
  DASHBOARD = "dashboard",
}

/** The ticket this one is marked as a duplicate of. */
export interface IssueParent {
  id: string;
  key: number;
  title: string | null;
  pretty_title: string;
}

export interface Issue {
  additional_data: string;
  app_id: string;
  app_version: string;
  assignee: IssueAssignee;
  sdk_version: string;
  created: string;
  updated: string;
  issue_reported_time: string;
  device: string;
  files: Array<File>;
  tags: Tag[];
  id: string;
  locale: string;
  os_version: string;
  os_name: string;
  permissions: Array<Permission>;
  screenshot_url: string;
  video_url: string;
  session_replay_url: string;
  timezone: string;
  title: string;
  key: number;
  device_orientation: number;
  connection_type: string;
  battery_percentage: number;
  battery_status: string;
  available_disk_space: number;
  used_memory: number;
  used_application_memory: number;
  available_memory: number;
  free_disk_space: number;
  session_length: number;
  current_view: string;
  screen_height: number;
  screen_width: number;
  ssid: string;
  city: string;
  country: string;
  report_type: ReportType;
  screen_density: string;
  cellular_network_type: string;
  metadata_: { [key: string]: string }; // this is json type column in postgresql
  authentication: string;
  blackbox: Blackbox;
  pretty_title: string;
  pretty_locale: string;
  pretty_timezone: string;
  pretty_battery_status: string;
  pretty_low_power_mode: string;
  pretty_memory_status: string;
  pretty_used_application_memory: string;
  pretty_storage_status: string;
  pretty_session_length: string;
  pretty_network_status: string;
  pretty_location: string;
  pretty_os: string;
  pretty_app_version: string;
  pretty_xcode_version: string;
  pretty_device_name: string;
  pretty_device_orientation: string;
  pretty_resolution: string;
  pretty_screen_density: string;
  pretty_screenshot_url: string;
  pretty_authentication: string;
  pretty_time: string;
  pretty_reported_time_in_list: string;
  pretty_reported_time_in_bug_pane: string;
  pretty_fullstory_session: string;
  priority: IssuePriority;
  public_url: string;
  public_key: string;
  public_key_updated: string;
  tags_in_list_tooltip: string;
  pretty_tester_email: string;
  pretty_is_portrait_mode: boolean;
  log: string; // returned log gui
  logs: Log;
  active: boolean;
  permalink: string;
  status: IssueStatus;
  service_hook_permalinks: Array<IssueServiceHookPermalink>;
  app_user: AppUserShared;
  timeSinceInBugList: string;
  custom_fields?: Array<IssueCustomField>;
  nfc: string;
  pretty_nfc: string;
  font_scale: string;
  pretty_font_scale: string;
  tester_email: string | null;
  app_user_id: string | null;
  parent_id: string | null;
  parent: IssueParent | null;
  linked_issues_count: number;
  browser_height: number;
  browser_width: number;
  pretty_browser_resolution: string;
  browser_name: string;
  browser_version: string;
  cookies_enabled: boolean;
  is_mobile: boolean;
  cpu_arch: string;
  pretty_browser: string;
  network_type: string;
  pretty_is_mobile: string;
  pretty_cookies_enabled: string;
  searchable_network_status: string;
  suggest_duplicate: boolean;
  is_limited: boolean;
}

export interface TicketsIssueResponse {
  items: Issue[];
  total: number;
  current_month_issues: number;
}
